'use strict';

angular.module('lingApp')
  .service('RipDom', function ($document, $window) {
    var cache = {};

    function getStyle(el, cssProp) {
      if (el.currentStyle) { // IE
        return el.currentStyle[cssProp];

      } else if ($window.getComputedStyle) {
        return $window.getComputedStyle(el)[cssProp];

      } else {
        return el.style[cssProp];
      }
    }

    function isStaticPositioned(element) {
      return 'static' === (getStyle(element, 'position') || 'static');
    }

    function parentOffsetElement(element) {
      var docDomElement = $document[0];
      var offsetParent = element.offsetParent || docDomElement;
      while (offsetParent
             && offsetParent !== docDomElement
             && isStaticPositioned(offsetParent)) {
        offsetParent = offsetParent.offsetParent;
      }

      return offsetParent || docDomElement;
    }

    return {
      getChildAtIndex: function(parent, index) {
        if (index < 0) return null;

        var count = 0, child = parent[0].firstChild;
        while (child) {
          if (1 === child.nodeType) {
            if (index === count) {
              return angular.element(child);
            }

            ++count;
          }

          child = child.nextSibling;
        }

        return null;
      },

      indexOf: function(parent, toFind) {
        var index = 0, child = parent[0].firstChild;
        toFind = toFind[0];

        while (child) {
          if (child === toFind) {
            return index;
          }

          if (1 === child.nodeType) {
            ++index;
          }

          child = child.nextSibling;
        }

        return -1;
      },

      position: function(element) {
        var elementBoundingClientRect = this.offset(element);
        var offsetParentBoundingClientRect = { top: 0, left: 0 };
        var offsetParentElement = parentOffsetElement(element[0]);
        if (offsetParentElement !== $document[0]) {
          offsetParentBoundingClientRect = this.offset(angular.element(offsetParentElement));
          offsetParentBoundingClientRect.top += offsetParentElement.clientTop - offsetParentElement.scrollTop;
          offsetParentBoundingClientRect.left += offsetParentElement.clientLeft - offsetParentElement.scrollLeft;
        }

        var boundingClientRect = element[0].getBoundingClientRect();

        return {
          width: boundingClientRect.width || element.prop('offsetWidth'),
          height: boundingClientRect.height || element.prop('offsetHeight'),
          top: elementBoundingClientRect.top - offsetParentBoundingClientRect.top,
          left: elementBoundingClientRect.left - offsetParentBoundingClientRect.left
        };
      },

      offset: function(element) {
        var boundingClientRect = element[0].getBoundingClientRect();

        return {
          width: boundingClientRect.width || element.prop('offsetWidth'),
          height: boundingClientRect.height || element.prop('offsetHeight'),
          top: boundingClientRect.top + ($window.pageYOffset
                                         || $document[0].documentElement.scrollTop),
          left: boundingClientRect.left + ($window.pageXOffset
                                           || $document[0].documentElement.scrollLeft)
        };
      },

      scrollbarWidth: function() {
        if (angular.isDefined(cache.scrollbarWidth)) {
          return cache.scrollbarWidth;
        }

        var div = angular.element('<div></div>');
        div.css({ width: '100px',
                  height: '100px',
                  overflow: 'scroll',
                  position: 'absolute',
                  top: '-9999px' });
        angular.element($document[0].body).append(div);

        cache.scrollbarWidth = div[0].offsetWidth - div[0].clientWidth;

        div.remove();

        return cache.scrollbarWidth;
      },

      focusinOrFocus: function() {
        return (this.isFirefox() ? 'focus' : 'focusin');
      },

      focusoutOrBlur: function() {
        return (this.isFirefox() ? 'blur' : 'focusout');
      },

      isFirefox: function() {
        return -1 < navigator.userAgent.toLowerCase().indexOf('firefox');
      },

      isMobile: function() {
        return (/(iPad|iPhone|iPod|Android|BlackBerry|Opera Mini|IEMobile)/gi).test(navigator.userAgent);
      }
    };
  })
;
